<i18n src="../../locales/lang.json"></i18n>

<template>
  <div id="threadMenu" class="quicklink-menu plusmenu" style="display:none;">
    <nested-menu class="nested-menu" v-bind:isroot="true" @onclick="doClick" v-bind:parentexpanded="false" ref="nestedMenu"></nested-menu>
  </div>
  
</template>

<script>
  
  var menu = [];

  export default {
    name: "procedure-quicklink-menu",
    components: {

    },
    props: {
      /*
      favouriteid: {
        type: Number,
        default: -1
      },
      threadid: {
        type: Number,
        default: -1
      },
      */
    },
    data() {
      return {
        menu,
        favouriteid: -1,
        threadid: -1,
        threadname:''
      };
    },
    computed: {

    },

    methods: {
      doSomething(threadid, favouriteid, threadname) {
        this.threadid = threadid;
        this.favouriteid = favouriteid;
        this.threadname = threadname;
        this.loadMenu();
        var thisContext = this;
        setTimeout(function () {
          thisContext.menu[0].expanded = true;
          thisContext.$refs.nestedMenu.setData(thisContext.menu);
        }, 500);

      },
      loadMenu() {
        if (this.favouriteid != -1) {
          this.menu = [
            {
              dataId: 'mainbutton',
              iconclass: "icon-plus3",
              iconstyle: "font-size: 27px !important; padding:11px !important;",
              itemclass: "skin primary-button",
              orientation: "vertical",
              direction: "downleft",
              color: "white",
              bgColor: "#ccc",
              static: true,
              elements: [
                {
                  dataId: 'favouriteButton',
                  threadid: this.threadid,
                  favouriteid: this.favouriteid,
                  color: "#BAD1AA",
                  option: "settings",
                  iconclass: "icon-star-full2",
                  tooltip: this.$t('text')
                }
              ]
            }
          ]
        }
        else {
          this.menu = [
            {
              dataId: 'mainbutton',
              iconclass: "icon-plus3",
              iconstyle: "font-size: 27px !important; padding:11px !important;",
              itemclass: "skin primary-button",
              orientation: "vertical",
              direction: "downleft",
              color: "white",
              bgColor: "#ccc",
              static: true,
              elements: [
                {
                  dataId: 'favouriteButton',
                  threadname: this.threadname,
                  threadid: this.threadid,
                  favouriteid: this.favouriteid,
                  option: "settings",
                  iconclass: "icon-star-empty3",
                  tooltip: this.$t('text')
                }
              ]
            }
          ]
        }

        this.$refs.nestedMenu.setData(this.menu);
      },
      getDefaultSettings() {
        var s = { Property: [] };
        return s;
      },
      doClick(element) {
        this.$root.$emit("discuss-menu-click", element)
      }

    },
    mounted() {
      this.loadMenu();
      this.$root.$on('show_discussion_detail', this.doSomething);
    }
  };

</script>

<style scoped>

  .quicklink-menu {
    display: inline-block;
    position: fixed;
    z-index: 1048;
    width:0px;
    height:0px;
    width:50px;
    right:18px;
  }

  .nested-menu {
   
  }

  @media (min-width: 768px) {
    .quicklink-menu {

    }

    .nested-menu {
     
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/discuss/discuss-menu.vue